export default "__VITE_ASSET__CjA7uGHA__"